let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cn1fk")).then(() => parcelRequire('oJqxg'));